import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Некоторые фронты используют query для менджмента своего стейта. При создании стора
 * query строка может быть еще не заполненной (и фронт ее зафиксирует). При перехода с одного фронта на другой
 * - query может быть перезаписана на пустую.
 */
export const usePersistentLocationSearch = () => {
  const location = useLocation()
  useEffect(() => {
    if (!window.location.search) {
      window.history.replaceState(null, '', location.search)
    }
  }, [window.location.search])
}
